import { render, staticRenderFns } from "./qualityPoints.vue?vue&type=template&id=0c9efde0&scoped=true&"
import script from "./qualityPoints.vue?vue&type=script&lang=ts&"
export * from "./qualityPoints.vue?vue&type=script&lang=ts&"
import style0 from "./qualityPoints.vue?vue&type=style&index=0&id=0c9efde0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9efde0",
  null
  
)

export default component.exports